import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AlertController, Events, Platform} from "ionic-angular";
import {GlobalvarsProvider} from "../globalvars/globalvars";
import {LoggerProvider, LogLevel} from "../logger/logger";
import {TranslateService} from "@ngx-translate/core";
import {Storage} from '@ionic/storage';
import {Subject} from "rxjs";
import CryptoJS from 'crypto-js';
import moment from 'moment';
// import * as isNullOrEmpty from 'isnullorempty';
// import * as notDefined from 'not-defined'; // SIA-21
import notDefined from 'not-defined';


interface ApiResponse {
  success: boolean;
  message: string;
  data: any;
  meta: any;
}

interface ApiResponseFallback {
  success: boolean;
  message: string;
  data: any;
  fallback: any;
  meta: any;
}

@Injectable()
export class ApiProvider {

  public INVALID_SESSION: string = 'Session not found or invalid';
  public TRACK_NOT_FOUND: string = 'Track konnte nicht gefunden werden';

  private log_level: LogLevel = LogLevel.Error;
  private log_label_main: string = "ApiProvider";

  private instantiated: boolean = false;

  public navTypeEvent: Subject<any> = new Subject<any>();

  private credentials: any = {
    dev_local: {
      /**/
      url: "http://sas-dev.gi.net/api/",
      key: "remote_app_api_tester",
      secret: "9WZDGAGQS9lGJcQHAx7j5PSdC8I01e7F",
      prefix: false/**/
      /*/
      url: "https://api-dev.s12.de/",
      key: "remote_app",
      secret: "iN7V8RfQ6G89jvHoUiKeo34667oK9jk8",
      prefix: true/*/
    },
    dev: {
      url: "https://api-dev.s12.de/",
      key: "remote_app",
      secret: "iN7V8RfQ6G89jvHoUiKeo34667oK9jk8"
    },
    live: {
      url: "https://api.s12.de/",
      key: "remote_app",
      secret: "zrH686tyzPEmg38w2EL3o3yq9nhbWfIl"
    }
  };

  prefix: string = "SAS";
  api_sas: string = "sas/";
  api_streaming: string = "streaming/";
  api_logger: string = "logger/";
  url: string;
  key: string;
  secret: string;

  keepAliveTime: number = 5; // minutes
  keepAliveLastRun: moment.Moment = null;
  keepAliveActive: boolean = false;

  sessionkey: string = "";
  refresh_token: string = null;
  refresh_session: boolean = false;
  user_id: number = null;

  //debugCount: number = 0;

  private offline_message: string;
  private alert: any;

  selectedApi: string;

  private isRefreshingSession: boolean = false;


  constructor(
    public http: HttpClient,
    public alertCtrl: AlertController,
    public storage: Storage,
    public globalvarsProvider: GlobalvarsProvider,
    public translateService: TranslateService,
    public platform: Platform,
    private logger: LoggerProvider,
    public events: Events,
  ) {
    let me = this;
    let log_label: string = me.log_label_main + '::constructor';
    me.logger.setLogLevel(me, LogLevel.Warning);

    me.logger.warn(me, log_label);

    me.logger.setApiProvider(me);

    // 2019-03-23, global cron
    me.events.subscribe('cron:run', (background: boolean) => {
      me.runCron(background);
    });
  }

  appReady(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::appReady';

    me.logger.warn(me, log_label);

    // promises
    let promises: Array<any> = [];

    return new Promise((resolve, reject) => {
      if (!me.instantiated) {
        // not instantiated
        me.instantiated = true;

        // init api
        promises.push(me.initApi());

        // init vars
        promises.push(me.initVars());

        // init session
        promises.push(me.initSession());

        // init user
        promises.push(me.initUser());

        Promise.all(promises).then(() => {
          me.logger.warn(me, log_label + ':resolve');

          me.logger.setLogLevel(me, me.log_level);

          resolve();

        }, error => {
          me.logger.error(me, log_label + ':error', {error: error});

          me.logger.setLogLevel(me, me.log_level);

          reject(error);
        });

      } else {
        // instantiated
        me.logger.info(me, log_label + ':resolve');

        resolve();
      }
    });
  }

  afterAppReady(): void {
    let me = this;
    let log_label = me.log_label_main + '::afterAppReady';

    me.logger.warn(me, log_label);

    // messages
    me.translateService.get("loading_text_offline").subscribe(value => {
      me.logger.debug(me, log_label, {translation: value});
      me.offline_message = value;
    });
  }

  private initVars(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::initVars';

    me.logger.warn(me, log_label);

    return new Promise(resolve => {
      me.sessionkey = '';
      me.refresh_token = null;
      me.user_id = null;

      me.logger.info(me, log_label + ':resolve');

      resolve();
    });
  }

  private initApi(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::initApi';

    me.logger.warn(me, log_label);

    return new Promise(resolve => {
      let hostname = window.location.hostname;
      me.logger.info(me, log_label, {hostname: hostname});

      switch (hostname) {
        case 'audi-sound.com':
        case 'www.audi-sound.com':

        case 'adidas.s12.de':

        case 'telekom.s12.de':

        case 'porsche.s12.de':

        case 'remoteapp.s12.de':
        case 'webapp.s12.de':
          me.globalvarsProvider.apiType = me.selectedApi = "live";

          // 2019-01-14
          me.globalvarsProvider.logConfig = false;

          me.url = me.credentials.live.url;
          me.key = me.credentials.live.key;
          me.secret = me.credentials.live.secret;

          me.logger.info(me, log_label + ':byHostname', {selectedApi: me.selectedApi, url: me.url});
          break;

        case 'dev.audi-sound.com':

        case 'remoteapp-dev.s12.de':
        case 'webapp-dev.s12.de':
          me.globalvarsProvider.apiType = me.selectedApi = "dev";

          me.url = me.credentials.dev.url;
          me.key = me.credentials.dev.key;
          me.secret = me.credentials.dev.secret;

          me.logger.info(me, log_label + ':byHostname', {selectedApi: me.selectedApi, url: me.url});
          break;

        default:

          switch (me.globalvarsProvider.apiType) {
            case "dev_local":
              me.selectedApi = "dev_local";

              me.url = me.credentials.dev_local.url;
              me.key = me.credentials.dev_local.key;
              me.secret = me.credentials.dev_local.secret;
              if (!me.credentials.dev_local.prefix) {
                me.api_sas = '';
                me.api_streaming = '';
              }

              me.logger.info(me, log_label + ':byGlobalVars', {selectedApi: me.selectedApi, url: me.url});
              break;

            case "dev":
              me.selectedApi = "dev";

              me.url = me.credentials.dev.url;
              me.key = me.credentials.dev.key;
              me.secret = me.credentials.dev.secret;

              me.logger.info(me, log_label + ':byGlobalVars', {selectedApi: me.selectedApi, url: me.url});
              break;

            default:
              me.selectedApi = "live";

              me.url = me.credentials.live.url;
              me.key = me.credentials.live.key;
              me.secret = me.credentials.live.secret;

              me.logger.info(me, log_label + ':byGlobalVars', {selectedApi: me.selectedApi, url: me.url});
              break;

          }

          break;
      }

      me.logger.info(me, log_label + ':resolve');
      resolve();
    });
  }

  private initSession(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::initSession';

    me.logger.warn(me, log_label);

    return new Promise((resolve, reject) => {
      // session
      if (
        notDefined(me.sessionkey)
        &&
        notDefined(me.refresh_token)
      ) {
        me.storage.get('session').then(session => {
          me.logger.info(me, log_label + ":session:loaded", {session: session});

          if (!notDefined(session)) {
            me.sessionkey = session.sessionkey;
            me.refresh_token = session.refresh_token;

            // 2018-11-27
            me.logger.info(me, log_label + ':resolve');
            resolve();

          } else {
            me.logger.error(me, log_label + ":session:empty");
            resolve();
          }

        }, error => {
          me.logger.error(me, log_label + ":session:error", {error: error});
          reject(error);
        });

      } else {
        me.logger.info(me, log_label + ':resolve');
        resolve();
      }
    });
  }

  private initUser(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::initUser';

    me.logger.warn(me, log_label);

    return new Promise((resolve, reject) => {
      // user
      if (
        notDefined(me.user_id)
      ) {
        me.storage.get('user').then(user => {
          me.logger.info(me, log_label + ":user:loaded", {user: user});

          if (!notDefined(user)) {
            me.user_id = user.id;

            // 2018-11-14
            me.globalvarsProvider.setUser(user);

            // 2019-01-09
            me.initKeepAlive();

            // 2018-11-27
            me.logger.info(me, log_label + ':resolve');

            resolve();

          } else {
            me.logger.error(me, log_label + ":user:empty");

            resolve();
          }

        }, error => {
          me.logger.error(me, log_label + ":user:error", {error: error});

          reject(error);
        });

      } else {
        me.logger.info(me, log_label + ':resolve');

        resolve();
      }
    });
  }

  runCron(background: boolean): void {
    const me = this;
    let log_label = me.log_label_main + '::runCron';

    me.logger.warn(me, log_label, {
      background: background,
      keepAliveLastRun: me.logger.formatMoment(me.keepAliveLastRun)
    });

    // keep alive
    if (!me.keepAliveLastRun) {
      // not run yet
      me.runKeepAlive();

    } else {

      let nextRun: moment.Moment = moment().subtract(me.keepAliveTime, 'minutes');
      if (nextRun > me.keepAliveLastRun) {
        // run again
        me.runKeepAlive();
      }

    }
  }

  runKeepAlive(): void {
    let me = this;
    let log_label = me.log_label_main + '::runKeepAlive';

    me.logger.warn(me, log_label);
    me.logger.warn(me, log_label, {
      keepAliveTime: me.keepAliveTime,
      keepAliveActive: me.keepAliveActive
    });

   if (me.keepAliveActive) {

     me.keepAliveLastRun = moment();

     me.callKeepAlive()
       .then(() => {})
       .catch(() => {})
     ;

   }
  }

  stopKeepAlive(): void {
    let me = this;
    let log_label = me.log_label_main + '::stopKeepAlive';

    me.logger.warn(me, log_label);
    me.logger.warn(me, log_label, {
      keepAliveTime: me.keepAliveTime,
      keepAliveActive: me.keepAliveActive
    });

    me.keepAliveActive = false;
  }

  private initKeepAlive(): void {
    let me = this;
    let log_label = me.log_label_main + '::initKeepAlive';

    me.logger.warn(me, log_label);
    me.logger.warn(me, log_label, {
      keepAliveTime: me.keepAliveTime,
      keepAliveActive: me.keepAliveActive
    });

    me.keepAliveActive = true;
  }

  callLogin(loading: any, username: string, password: string): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callLogin';

    me.logger.warn(me, log_label);

    const data = {
      username: username,
      password: password
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise((resolve, reject) => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "login", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
      }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          loading.dismiss().then(() => {
            if (!data.success) {
              // api return error
              me.initVars();
              me.showErrorMessage(data.message);

              // WEBAPP-4, 2019-01-25
              reject(data.message);

            } else {
              // api return success
              me.storage.set('user', data.data.user).then(() => {
                me.logger.debug(me, log_label + ':set_user:done', {result: data.data});

                // 2018-11-14
                me.globalvarsProvider.setUser(data.data.user);

                // 2019-01-09
                me.initKeepAlive();

                me.logger.debug(me, log_label + ":set_session", {
                  sessionkey: data.data.sessionkey,
                  refresh_token: data.data.refresh_token
                });

                // SIA-21, 2019-01-28
                me.setRefreshToken(data).then(() => {
                  resolve(data.data);

                }, error => {
                  resolve(data.data);
                });

              }, error => {
                me.logger.debug(me, log_label + ':set_user:error', {error: error});
              });

            }
          });

        }, error => {
          me.initVars();

          me.hideLoadingShowError(loading, error.message);

          // WEBAPP-4, 2019-01-25
          reject(error.message);
        });
    });
  }

  private setRefreshToken(data: any): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::setRefreshToken';

    me.logger.warn(me, log_label);
    me.logger.warn(me, log_label, {data: data});

    return new Promise((resolve, reject) => {

      if (!notDefined(data.data.user)) {
        me.logger.warn(me, log_label, {user: data.data.user});
        me.user_id = parseInt(data.data.user.id, 10);
      }

      me.sessionkey = data.data.sessionkey;

      if (!notDefined(data.data.refresh_token)) {
        me.refresh_token = data.data.refresh_token;

        me.logger.warn(me, log_label + ':session', {
          sessionkey: me.sessionkey,
          refresh_token: me.refresh_token
        });

        me.storage.set("session", {
          sessionkey: me.sessionkey,
          refresh_token: me.refresh_token
        }).then(() => {
          me.logger.warn(me, log_label + ':session:set');

          resolve(data.data);

        }, error => {
          me.logger.error(me, log_label + ':session:set:error', {error: error});

          reject(error);

        });

      } else {
        let msg: string = "empty refresh token";

        me.logger.error(me, log_label + ':error', {error: msg});

        reject(msg);
      }
    });
  }

  callPasswordReset(loading: any, email:string): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callPasswordReset';

    me.logger.warn(me, log_label);

    const data = {
      email: email
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise(resolve => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "passwordforgotten", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.showErrorMessage(data.message);

            } else {
              // api return success
              me.logger.info(me, log_label + ":resolve_data");
              resolve(data.data);
            }
          });

        }, error => {
          me.hideLoadingShowError(loading, error.message);
        });
    });
  }

  callGetStreams(loading: any): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callGetStreams';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise((resolve, reject) => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "getstreams", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.showErrorMessage(data.message);

            } else {
              // api return success
              me.storage.set('streams', data.data).then(() => {
                me.logger.debug(me, log_label + ':set_streams:done', {result: data.data});

                me.logger.info(me, log_label + ":resolve_data");

                resolve(data.data);

              }, error => {
                me.logger.error(me, log_label + ':set_streams:error', {error: error});

                reject(error);
              });
            }
          });

        }, error => {
          me.hideLoadingShowError(loading, error.message);

          reject(error);
        });
    });
  }

  callPlayStream(loading: any, channel: any): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callPlayStream';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey,
      channel_id: channel.channel_id
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise(resolve => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "playstream", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.showErrorMessage(data.message);

            } else {
              // api return success
              me.storage.set('stream', data.data).then(() => {
                me.logger.debug(me, log_label + ':set_stream:done', {result: data.data});

                me.logger.info(me, log_label + ":resolve_data");
                resolve(data.data);

              }, error => {
                me.logger.debug(me, log_label + ':set_stream:error', {error: error});
              });
            }
          });

        }, error => {
          me.hideLoadingShowError(loading, error.message);
        });
    });
  }

  callGetChannels(loading: any, enableRefresh: boolean = false): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callGetChannels';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey
    };
    //data = this.checkRefreshToken(data);
    me.logger.info(me, log_label, {data: data, enableRefresh: enableRefresh});

    if (enableRefresh)
      me.refresh_session = true;

    return new Promise((resolve, reject) => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "getchannels", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.logger.warn(me, log_label + ":response:error", {message: data.message});

              if (!me.refresh_session) {
                // no refresh_token
                me.showErrorMessage(data.message);

              } else {
                // start refreshing token
                me.callRefreshSession(data).then(() => {
                  me.callGetChannels(loading, enableRefresh)
                    .then((data) => resolve(data), (error) => reject(error));

                }, error => {
                  // handle error
                  reject(error);

                });
              }

            } else {
              // api return success
              me.storage.set('channels', data.data.channels).then(() => {
                me.logger.debug(me, log_label + ':set_channels:done', {result: data.data});

                me.logger.info(me, log_label + ":resolve_data");
                resolve(data.data);

              }, error => {
                me.logger.debug(me, log_label + ':set_channels:error', {error: error});
                reject(error);
              });
            }
          });

        }, error => {
          me.hideLoadingShowError(loading, error.message);
          reject(error);
        });
    });
  }

  callGetCurrentPlaylist(channel_id: Number): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callGetCurrentPlaylist';

    me.logger.warn(me, log_label);

    me.logger.info(me, log_label, {channel_id: channel_id});

    return new Promise(resolve => {
      this.http.get<ApiResponse>(
        this.url + this.api_streaming + "getCurrentPlaylist/channel/" + channel_id
      ).subscribe(data => {
        me.logger.debug(me, log_label, {result: data});

        if (!data.success) {
          // api return error
          this.showErrorMessage(data.message);

        } else {
          // api return success
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":resolve_data");
          resolve(data);
        }

      }, error => {
        me.logger.error(me, log_label, {error: error});
      });
    });
  }

  callKeepAlive(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callKeepAlive';

    me.logger.warn(me, log_label);

    // SIA-25, 2019-02-03
    me.refresh_session = true;

    const data = {
      sessionkey: me.sessionkey
    };
    me.logger.warn(me, log_label, {
      data: data,
      refresh_session: me.refresh_session
    });

    return new Promise((resolve, reject) => {
      if (me.sessionkey == "") {
        me.logger.info(me, log_label + ":terminated");

        reject();
      }

      me.http.post<ApiResponse>(
        me.url + me.api_sas + "keepalive", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          if (data.success) {
            // REM-5, 2019-01-28, removed
            // SIA-25, 2019-02-03, added missing resolve()
            resolve();

          } else {
            // SIA-25, 2019-02-03, added refresh token call
            if (!me.refresh_session) {
              // no refresh_token
              reject(data.message);

            } else {
              // start refreshing token
              me.callRefreshSession(data).then(() => {
                me.callKeepAlive().then(() => resolve(), (error) => reject(error));

              }, error => {
                // handle error
                reject(error);

              });
            }
          }

        }, error => {
          me.logger.error(me, log_label, {error: error});

          reject(error);
        });
    });
  }

  callDoLogout(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callDoLogout';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise((resolve, reject) => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "logout", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          if (!data.success) {
            // api return error

            // 2019-01-27
            //me.showErrorMessage(data.message);
            reject(data.message);

          } else {
            // api return success
            me.logger.info(me, log_label + ":resolve_data");
            resolve(data);
          }

        }, error => {
          me.logger.error(me, log_label, {error: error});
          reject(error);
        });
    });
  }

  callLoadPlayers(loading: any, channel: any): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callLoadPlayers';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey,
      channel_id: channel.channel_id
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise(resolve => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "getplayers", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.showErrorMessage(data.message);

            } else {
              // api return success
              me.storage.set('players', data.data.players).then(() => {
                me.logger.debug(me, log_label + ':set_players:done', {result: data.data});

                me.logger.info(me, log_label + ":resolve_data");
                resolve(data.data);

              }, error => {
                me.logger.error(me, log_label + ':set_players:error', {error: error});
              });
            }
          });

        }, error => {
          me.hideLoadingShowError(loading, error.message);
        });
    });
  }

  callLoadAllPlayers(loading: any): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callLoadAllPlayers';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise(resolve => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "getplayers", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.showErrorMessage(data.message);

            } else {
              // api return success
              me.storage.set('players', data.data.players).then(() => {
                me.logger.debug(me, log_label + ':set_players:done', {result: data.data});

                me.logger.info(me, log_label + ":resolve_data");
                resolve(data.data);

              }, error => {
                me.logger.error(me, log_label + ':set_players:error', {error: error});
              });
            }
          });

        }, error => {
          me.hideLoadingShowError(loading, error.message);
        });
    });
  }

  callLoadPlayer(loading: any, player: any): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callLoadPlayer';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey,
      player_id: player.id,
      starttime: moment().toISOString()
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise(resolve => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "getplayeractions", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.showErrorMessage(data.message);

            } else {
              // api return success
              me.adjustPlayerData(data);
              me.storage.set('player', data.data).then(() => {
                me.logger.debug(me, log_label + ':set_player:done', {result: data.data});

                me.logger.info(me, log_label + ":resolve_data");
                resolve(data.data);

              }, error => {
                me.logger.error(me, log_label + ':set_player:error', {error: error});
              });
            }
          });

        }, error => {
          me.hideLoadingShowError(loading, error.message);
        });
    });
  }

  callGetPlaylists(loading: any, channel: any, fallback: boolean = false, enableRefresh: boolean = false): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callGetPlaylists';

    me.logger.warn(me, log_label, {channel_id: channel.channel_id});

    const data = {
      sessionkey: me.sessionkey,
      channel_id: channel.channel_id,
      fallback: fallback,
      // 2019-03-12
      meta: true
    };
    //data = me.checkRefreshToken(data);
    me.logger.info(me, log_label, {data: data, enableRefresh: enableRefresh});

    if (enableRefresh) {
      me.refresh_session = true;
    }

    return new Promise((resolve, reject) => {
    me.http.post<ApiResponseFallback>(
      me.url + me.api_sas + "getplaylists", me.httpParamSerializerJQLike(data), {
        headers: me.addAuthHeader(data)
    }).subscribe(data => {
      me.logger.debug(me, log_label, {channel_id: channel.id, result: data});

      if (!data.success) {
        // api return error
        me.logger.warn(me, log_label + ":response:error", {channel_id: channel.channel_id, message: data.message});

        if (!me.refresh_session) {
          // no refresh_token
          me.hideLoadingShowError(loading, data.message);

        } else {
          // start refreshing token
          me.callRefreshSession(data).then(() => {
            me.callGetPlaylists(loading, channel, fallback, enableRefresh)
              .then((data) => resolve(data), (error) => reject(error));

          }, error => {
            // handle error
            reject(error);

          });
        }
      } else {
        // api return success
        me.logger.warn(me, log_label + ":response:success", {meta: data.meta});

        let promises: any = [];

        // 2019-03-13
        let channel_id: string = data.meta.channel.id; // channel.channel_id

        // playlists
        let label = "playlists_" + channel_id;
        promises.push(me.storage.set(label, data.data).then(() => {
          me.logger.debug(me, log_label + ':set:' + label + ':done', {result: data.data});
        }));

        // falbacks
        let fallback_label = "fallbacks_" + channel_id;
        promises.push(me.storage.set(fallback_label, data.fallback).then(() => {
          me.logger.debug(me, log_label + ':set:' + fallback_label + ':done', {result: data.fallback});
        }));

        // all
        Promise.all(promises).then(() => {
          me.hideLoading(loading).then(() => {
            me.logger.info(me, log_label + ":resolve_data");
            resolve(data);
          });
        });
      }

    }, error => {
      me.hideLoadingShowError(loading, error.message);
      reject(error);
    });
  });
}

  callGetPlaylist(loading: any, channel: any, playlist_id: any, storage_label: string, enableRefresh: boolean = false): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callGetPlaylist';

    me.logger.warn(me, log_label, {channel_id: channel.channel_id});

    const data = {
      sessionkey: this.sessionkey,
      playlist_id: playlist_id,
      checksum: true,
      track_id: true,
      track_path: true,
      file_size: true,
      weekday: true,
      // 2019-03-12
      meta: true
    };
    //data = this.checkRefreshToken(data);

    let fallback: boolean = false;
    if (storage_label.includes("fallback")) {
      fallback = true;
      data["fallback"] = fallback;
    }
    me.logger.info(me, log_label, {data: data, enableRefresh: enableRefresh});

    if (enableRefresh)
      me.refresh_session = true;

    return new Promise((resolve, reject) => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "getplaylist", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
        me.logger.debug(me, log_label, {result: data});

          if (!data.success) {
            // api return error
            me.logger.warn(me, log_label + ":response:error", {channel_id: channel.channel_id, message: data.message});

            if (!me.refresh_session) {
              // no refresh_token
              me.hideLoadingShowError(loading, data.message);

            } else {
              // start refreshing token
              me.callRefreshSession(data).then(() => {
                me.callGetPlaylist(loading, channel, playlist_id, storage_label, enableRefresh)
                  .then((data) => resolve(data), (error) => reject(error));

              }, error => {
                // handle error
                reject(error);

              });
            }
          } else {
            // api return success
            me.logger.warn(me, log_label + ":response:success", {storage_label: storage_label});

            me.callGetPlaylistResult(loading, data, storage_label).then(data => resolve(data));
          }

        }, error => {
          me.hideLoadingShowError(loading, error.message);
          reject(error);
        });
    });
  }

  private hideLoading(loading: any): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::hideLoading';

    me.logger.warn(me, log_label);
    me.logger.debug(me, log_label, {loading: loading, loadingType: typeof loading});

    return new Promise((resolve, reject) => {
      if (!loading) {
        resolve();

      } else {
        try {
          loading.dismiss().then(() => {
            //loading = null;

            resolve();

          }, error => {
            resolve();
          });

        } catch(e) {
          resolve();
        }
      }
    });
  }

  private hideLoadingShowError(loading: any, message: string): void {
    const me = this;
    let log_label = me.log_label_main + '::hideLoadingShowError';

    me.logger.warn(me, log_label);
    me.logger.debug(me, log_label, {loading: loading, loadingType: typeof loading});

    me.hideLoading(loading).then(() => {
      me.showErrorMessage(message);
    });
  }

  callGetPlaylistResult(loading: any, data: any, storage_label: string): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callGetPlaylistResult';

    me.logger.warn(me, log_label);

    return new Promise((resolve, reject) => {
      me.hideLoading(loading).then(() => {
        if (!data.success) {
          // api return error
          me.showErrorMessage(data.message);

        } else {
          // api return success

          // remove id from data
          let playlist: any = data.data;
          /*playlist.map(function(item) {
            delete item.id;
            return item;
          });*/

          me.storage.set(storage_label, playlist).then(() => {
            me.logger.debug(me, log_label + ':set:' + storage_label + ':done', {result: data.data});

            me.logger.info(me, log_label + ":resolve_data");
            resolve(data.data);

          }, error => {
            me.logger.error(me, log_label + ':set:' + storage_label + ':done', {error: error});
          });
        }
      });
    });
  }

  callGetSecureDownload(channel: any, track_id: any, enableRefresh: boolean = false, fallback: boolean = false, isTrack: boolean = false): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callGetSecureDownload';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: this.sessionkey,
      track_id: track_id,
      track: isTrack, // track_id is tracklist_id
      size: true,
      // 2019-03-12
      meta: true
    };
    //data = this.checkRefreshToken(data);

    if (fallback) {
      data["fallback"] = true;
    }

    me.logger.info(me, log_label, {data: data, enableRefresh: enableRefresh});

    if (enableRefresh)
      me.refresh_session = true;

    return new Promise((resolve, reject) => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "getsecuredownload", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          if (!data.success) {
            // api return error
            me.logger.warn(me, log_label + ":response:error");

            if (!me.refresh_session) {
              // no refresh_token
              me.showErrorMessage(data.message);

            } else {
              // start refreshing token
              me.callRefreshSession(data).then(() => {
                me.callGetSecureDownload(channel, track_id, enableRefresh)
                  .then((data) => resolve(data), (error) => reject(error));

              }, error => {
                // handle error
                reject(error);

              });
            }
          } else {
            // api return success
            me.logger.warn(me, log_label + ":response:success");

            me.logger.info(me, log_label + ":resolve_data");
            resolve(data.data);
          }

        }, error => {
          //me.showErrorMessage(error.message);

          me.logger.error(me, log_label + ':error', {error: error});

          reject(error);
        });
    });
  }

  callRefreshSession(last_data: any): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callRefreshSession';

    me.logger.warn(me, log_label, {message: last_data.message});

    return new Promise((resolve, reject) => {
      // 2019-03-23
      if (me.isRefreshingSession) {
        reject(new Error('already refreshing'));

      } else if (last_data.message == me.INVALID_SESSION) {
        let data = {
          sessionkey: me.sessionkey
        };
        data = me.checkRefreshToken(data);

        // 2019-03-23
        me.isRefreshingSession = true;

        me.logger.warn(me, log_label, {data: data, isRefreshingSession: me.isRefreshingSession});

        me.http.post<ApiResponse>(
          me.url + me.api_sas + "refreshsession", me.httpParamSerializerJQLike(data), {
            headers: me.addAuthHeader(data)
          }).subscribe(data => {
            me.logger.debug(me, log_label + ':data', {data: data});

            if (!data.success) {
              // api return error
              me.logger.error(me, log_label + ':data:error', {error: data.message});

              me.showErrorMessage(data.message);

              // 2019-03-23
              me.isRefreshingSession = false;

              reject(data.message);

            } else {
              // api return success
              me.logger.debug(me, log_label + ':data:save');

              // SIA-21, 2019-01-28
              me.setRefreshToken(data).then(() => {
                me.logger.debug(me, log_label + ':data:save:done');

                // 2019-03-23
                me.isRefreshingSession = false;

                resolve(data);

              }, error => {
                me.logger.error(me, log_label + ':data:save:error', {error: error});

                // 2019-03-23
                me.isRefreshingSession = false;

                reject(error);
              });
            }

          }, error => {
            me.logger.error(me, log_label + ':error', {error: error});

            me.showErrorMessage(error.message);

            // 2019-03-23
            me.isRefreshingSession = false;

            reject(error);
          });

      } else {
        let msg: string = last_data.message + ' (no refresh session needed)';

        me.logger.error(me, log_label + ':error', {error: msg});

        reject(msg);
      }
    });
  }

  callDeleteSession(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callDeleteSession';

    me.logger.warn(me, log_label);

    return new Promise((resolve, reject) => {
      let data = {
        sessionkey: me.sessionkey
      };
      //data = me.checkRefreshToken(data);

      me.logger.warn(me, log_label, {data: data});

      me.http.post<ApiResponse>(
        me.url + me.api_sas + "deletesession", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
        me.logger.debug(me, log_label + ':data', {data: data});

        if (!data.success) {
          // api return error
          me.logger.error(me, log_label + ':data:error', {error: data.message});

          //me.showErrorMessage(data.message);

          reject(data.message);

        } else {
          // api return success
          me.logger.debug(me, log_label + ':data:save');

          resolve(data);
        }

      }, error => {
        me.logger.error(me, log_label + ':error', {error: error});

        //me.showErrorMessage(error.message);

        reject(error);
      });
    });
  }

  callInvalidateAccessToken(): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callInvalidateAccessToken';

    me.logger.warn(me, log_label);

    return new Promise((resolve, reject) => {
        let data = {
          sessionkey: me.sessionkey
        };
        data = me.checkRefreshToken(data);

        me.logger.warn(me, log_label, {data: data});

        me.http.post<ApiResponse>(
          me.url + me.api_sas + "invalidatesession", me.httpParamSerializerJQLike(data), {
            headers: me.addAuthHeader(data)
          }).subscribe(data => {
          me.logger.debug(me, log_label + ':data', {data: data});

          if (!data.success) {
            // api return error
            me.logger.error(me, log_label + ':data:error', {error: data.message});

            //me.showErrorMessage(data.message);

            reject(data.message);

          } else {
            // api return success
            me.logger.debug(me, log_label + ':data:save');

            resolve(data);
          }

        }, error => {
          me.logger.error(me, log_label + ':error', {error: error});

          //me.showErrorMessage(error.message);

          reject(error);
        });
    });
  }

  private adjustPlayerData(data: any): void {
    let me = this;
    let log_label = me.log_label_main + '::adjustPlayerData';

    me.logger.warn(me, log_label);

    me.logger.info(me, log_label, {data: data});

    for (let channel in data.data) {
      if (data.data[channel].music.state != 'offline') {
        data.data[channel].music.elapsed = data.data[channel].music.elapsed + data.time.process;
        if (data.data[channel].music.elapsed > data.data[channel].music.duration) {
          data.data[channel].music.elapsed = data.data[channel].music.duration;
        }
      }
    }
  }

  callSetVolume(loading: any, player: any, volume: number, type: string, channel: string): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callSetVolume';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey,
      volume: volume,
      type: type,
      channel: channel,
      player_id: player.id
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise(resolve => {
      me.http.post(
        me.url + me.api_sas + "setplayervolume", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          /*/if (debug) console.log(log_label + ":close loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.showErrorMessage(data.message);
            } else {
              // api return success
              me.storage.set('player', data.data).then(() => {
                console.log('player saved');

                if (debug) console.log("resolve data");
                resolve(data.data);
              });
            }
          });/**/

        }, error => {
          me.hideLoadingShowError(loading, error.message);
        });
    });
  }

  callPlayPlayerEvent(loading: any, player: any, event: string, channel: string): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callPlayPlayerEvent';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey,
      channel: channel,
      type: 'event',
      event: encodeURIComponent(event),
      player_id: player.id
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise(resolve => {
      me.http.post(
        me.url + me.api_sas + "playplayerevent", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          /*/if (debug) console.log(log_label + ":close loading");
          me.hideLoading(loading).then(() => {
            if (!data.success) {
              // api return error
              me.showErrorMessage(data.message);
            } else {
              // api return success
              me.storage.set('player', data.data).then(() => {
                console.log('player saved');

                if (debug) console.log("resolve data");
                resolve(data.data);
             });
           }
          });/**/

        }, error => {
          me.hideLoadingShowError(loading, error.message);
        });
    });
  }

  callTogglePlayerChannel(view: any, loading: any, player: any, active: boolean, channel: string, exclusive: boolean): Promise<any> {
    let me = this;
    let log_label = me.log_label_main + '::callTogglePlayerChannel';

    me.logger.warn(me, log_label);

    const data = {
      sessionkey: me.sessionkey,
      channel: channel,
      active: active,
      exclusive: exclusive,
      player_id: player.id
    };
    me.logger.info(me, log_label, {data: data});

    return new Promise(resolve => {
      me.http.post<ApiResponse>(
        me.url + me.api_sas + "toggleplayerchannel", me.httpParamSerializerJQLike(data), {
          headers: me.addAuthHeader(data)
        }).subscribe(data => {
          me.logger.debug(me, log_label, {result: data});

          me.logger.info(me, log_label + ":close_loading");
          if (loading) {
            loading.dismiss().then(() => {
              if (!data.success) {
                // api return error
                me.showErrorMessage(data.message);

              } else {
                // api return success
                if (exclusive) {
                  // handle exclusive
                  view.doRefresh();

                } else {
                  if (active) {
                    // handle normal activation
                    me.logger.debug(me, log_label + 'reset_volume', {result: data});
                    view.resetVolume(data.data.volume, channel);
                  }
                }
              }
            });

          } else if (!loading && !exclusive && data.success && active) {
            me.logger.debug(me, log_label + 'reset_volume', {result: data});
            view.resetVolume(data.data.volume, channel);
          }

        }, error => {
          me.hideLoadingShowError(loading, error.message);
        });
    });
  }

  private checkRefreshToken(data: any): any {
    let me = this;
    let log_label = me.log_label_main + '::checkRefreshToken';

    me.logger.warn(me, log_label);
    me.logger.warn(me, log_label, {
      refresh_session: me.refresh_session,
      refresh_token: me.refresh_token,
      refresh_token_chack: notDefined(me.refresh_token),
      user_id: me.user_id,
      user_id_chack: notDefined(me.user_id),
    });

    if (
      !notDefined(me.refresh_token)
      &&
      me.refresh_session
    ) {
      data.refresh_token = me.refresh_token;
    }

    if (
      !notDefined(me.user_id)
      &&
      me.refresh_session
    ) {
      data.user_id = me.user_id;
    }

    me.refresh_session = false;

    me.logger.warn(me, log_label, {
      data: data,
      refresh_session: me.refresh_session
    });

    return data;
  }

  private addAuthHeader(data: any): HttpHeaders {
    let me = this;
    let log_label = me.log_label_main + '::addAuthHeader';

    me.logger.info(me, log_label);
    me.logger.info(me, log_label, {data: data});

    const timestamp: string = (me.getMicrotime(true)*1000).toString();
    const hash :string = me.getHMAC(data, timestamp, me.secret);
    me.logger.info(me, log_label, {hash: hash});

    const authorization: string = me.prefix+timestamp + me.key + ":" + hash;
    me.logger.info(me, log_label, {authorization: authorization});

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers = headers.append('Authorization', authorization);
    me.logger.info(me, log_label, {headers: headers});

    return headers;
  }

  private getMicrotime(get_as_float: boolean): any {
    let now: any = new Date().getTime() / 1000;
    let s: number = parseInt(now, 10);

    return (get_as_float) ? now : (Math.round((now - s) * 1000) / 1000) + ' ' + s;
  }

  private getHMAC(data: any, timestamp: string, secret: string): string {
    let me = this;
    let log_label = me.log_label_main + '::getHMAC';

    me.logger.info(me, log_label);
    me.logger.info(me, log_label, {data: data});

    let key: string = me.httpParamSerializerJQLike(data);
    me.logger.info(me, log_label, {key: key, timestamp: timestamp});

    //let text = decodeURIComponent(key+timestamp);
    let text = key + timestamp;
    me.logger.info(me, log_label, {text: text});

    let hash = CryptoJS.HmacSHA1(text, secret);
    me.logger.info(me, log_label, {hash: hash});

    return hash.toString();
  }

  private httpParamSerializerJQLike(data: any): string {
    let me = this;
    let log_label = me.log_label_main + '::httpParamSerializerJQLike';

    me.logger.info(me, log_label);

    let params: URLSearchParams = new URLSearchParams();

    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        let element = data[key];

        params.set(key, element);
      }
    }

    let result:string = params.toString();

    // jquery compatible
    result = result.replace("@", "%40");
    me.logger.info(me, log_label, {result: result});

    return result;
  }

  private showErrorMessage(message: string): void {
    let me = this;
    let log_label = me.log_label_main + '::showErrorMessage';

    me.logger.warn(me, log_label);
    me.logger.error(me, log_label, {message: message, messageType: typeof message, alertType: typeof me.alert});

    if (message) {
      // check for offline message
      let msg: string = message.toLowerCase();

      if (
        msg.includes("http failure response")
        &&
        msg.includes("unknown error")
      ) {
        // offline error
        message = me.offline_message;

        // 2019-03-19, offline event
        me.events.publish('apiStatus:offline');
      }

      // hide alert
      if (me.alert) {
        me.alert.dismiss();
      }

      me.alert = this.alertCtrl.create({
        message: message,
        buttons: [{
          text: "Ok",
          role: 'cancel',
          handler: () => {
            me.logger.debug(me, log_label + ':clicked', {message: message, messageType: typeof message});

            if (typeof message == "string" && message == "refreshtoken invalid") {
              me.navTypeEvent.next("logout");
            }
          }
        }]
      });
      me.alert.present();

    } else {
      me.logger.error(me, log_label, "empty message");
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts